import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }

import {
  CheckCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'PropNotification',
  props: {
  notification: {
    type: String,
    required: true,
  },
  notificationType: {
    type: String,
    required: true,
  },
  maxWidth: {
    type: String,
    default: '360px',
  },
},
  emits: ["close"],
  setup(__props) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "alert fixed inset-x-0 top-20 z-[1000] mx-auto w-fit bg-white shadow-lg shadow-gray-500",
    style: _normalizeStyle({ maxWidth: __props.maxWidth })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.notificationType === 'INFO')
        ? (_openBlock(), _createBlock(_unref(InformationCircleIcon), {
            key: 0,
            class: "h-8 min-w-[32px] text-yellow-500"
          }))
        : (__props.notificationType === 'SUCCESS')
          ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
              key: 1,
              class: "h-8 min-w-[32px] text-blue-500"
            }))
          : (__props.notificationType === 'ERROR')
            ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                key: 2,
                class: "h-8 min-w-[32px] text-red-500"
              }))
            : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(__props.notification), 1),
      _createElementVNode("button", {
        type: "button",
        class: "min-h-full min-w-[32px] rounded-lg p-1.5 text-blue-500",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_unref(XMarkIcon), { class: "h-6 w-6" })
      ])
    ])
  ], 4))
}
}

})